import { render, staticRenderFns } from "./service-user-list.vue?vue&type=template&id=a3a7b80c&scoped=true"
import script from "./service-user-list.vue?vue&type=script&lang=js"
export * from "./service-user-list.vue?vue&type=script&lang=js"
import style0 from "./service-user-list.vue?vue&type=style&index=0&id=a3a7b80c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a7b80c",
  null
  
)

export default component.exports